import styled from 'styled-components';

export const HUDWrapper = styled.div`
  position: absolute;
  bottom: 1.5rem;
  left: 1rem;
  z-index: 10000;
  pointer-events: auto;
  width: 210px;
  overflow: hidden;
`;

export const BottomRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 0 0.4rem;
  border-bottom: 1px solid ${({ theme }) => theme.colors('foreground', 0.1)};
  margin-bottom: 0.25rem;
  min-width: 0;
  gap: 0.3rem;
`;

export const ColorSwatch = styled.div`
  width: 14px;
  height: 14px;
  border-radius: 2px;
  border: 1px solid ${({ theme }) => theme.colors('foreground', 0.25)};
  background: ${({ $color }) => $color};
  flex-shrink: 0;
`;

export const RecentRow = styled.div`
  display: flex;
  gap: 0.3rem;
  padding: 0.3rem 0 0.4rem;
`;

export const RecentSwatch = styled.div`
  width: 18px;
  height: 18px;
  border-radius: 2px;
  border: 1px solid ${({ $active, theme }) => $active ? theme.colors('text') : theme.colors('foreground', 0.25)};
  background: ${({ $color }) => $color};
  cursor: pointer;
  flex-shrink: 0;
  &:hover {
    border-color: ${({ theme }) => theme.colors('text')};
  }
`;
